import { render } from "./job-opportunities.vue?vue&type=template&id=4517b720&scoped=true"
import script from "./job-opportunities.vue?vue&type=script&lang=js"
export * from "./job-opportunities.vue?vue&type=script&lang=js"

import "./job-opportunities.vue?vue&type=style&index=0&id=4517b720&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4517b720"

export default script